import React from 'react';
import '../Styles/LoadingScreen.css';
import Lottie from 'lottie-react';
import anime1 from '../animations/anime2.json';


const LoadingScreen = () => {
    return (
        <div className="loading-wrapper">
            <div className="glow-ring">
                <Lottie animationData={anime1} loop={true} className="loading-animation"/>
            </div>
            <h2 className="loading-title">MeduVR</h2>
            <p className="loading-subtitle">Sürükleyici deneyiminiz yükleniyor...</p>
        </div>
    );
};

export default LoadingScreen;